export default "__VITE_ASSET__Dy98f3xC__"